/**
 * ORCA 患者登録失敗レコードのステータス。
 *
 * `domain/index.ts` で `export * as Consultation` 経由で公開されるため、
 * 利用側からは `Consultation.OrcaRegistrationFailureStatus.Pending` のように参照される。
 */
export const OrcaRegistrationFailureStatus = {
    /** 再実行待ち */
    Pending: "pending",
    /** 解決済み */
    Resolved: "resolved",
};
